import { useLocation } from 'react-router-dom';
import { useUi } from '../i18n/uiTranslations';

export const TELEGRAM_URL = 'https://t.me/softmayaofficial';
export const TELEGRAM_PATH = 'M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z';

export const TelegramButton = () => {
  const u = useUi();
  const { pathname } = useLocation();
  if (pathname.startsWith('/website/admin')) return null;
  return (
    <a
      href={TELEGRAM_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={u('telegram')}
      className="group fixed right-5 sm:right-8 z-[60] w-14 h-14 rounded-full bg-[#0B0B0A] border border-[#C8AA73]/60 text-[#C8AA73] flex items-center justify-center shadow-[0_10px_40px_rgba(0,0,0,0.6)] hover:bg-[#C8AA73] hover:text-[#080808] hover:scale-105 transition-[background-color,color,transform] duration-300"
      style={{ bottom: 'calc(1.5rem + env(safe-area-inset-bottom))' }}
      data-testid="telegram-floating-btn"
    >
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d={TELEGRAM_PATH} /></svg>
      <span className="pointer-events-none absolute right-[calc(100%+12px)] whitespace-nowrap rounded-full bg-[#121212] border border-[#C8AA73]/30 px-4 py-2 text-sm text-[#F4F0E8] opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-[opacity,transform] duration-300" data-testid="telegram-tooltip">
        {u('telegram')}
      </span>
    </a>
  );
};
